/**
 * Formatters for CADMetadataPanel. Deliberately not utils/dateUtils'
 * formatFileSize: that one rounds to 2 significant decimals and labels bytes
 * "Bytes", so it would restate every size this panel already ships.
 */

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatNumber(n: number): string {
  return n.toLocaleString();
}

export type ConfidenceLevel = 'high' | 'medium' | 'low';

/** Anything the backend did not send as high/medium/low is treated as low. */
export function normalizeConfidence(confidence?: string): ConfidenceLevel {
  return confidence === 'high' || confidence === 'medium' ? confidence : 'low';
}

export const CONFIDENCE_BADGE_CLASS: Record<ConfidenceLevel, string> = {
  high: 'border-success/60 text-success',
  medium: 'border-warning/60 text-warning',
  low: 'border-destructive/60 text-destructive',
};
